import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenService } from '../../../../../core/services/token.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { ToastNotifService } from '../../../../../core/services/toastNotif.service';
import { LanguageService } from '../../../../../core/services/language.service';
import { CommonModule } from '@angular/common';
import { Color, InformationResponse, InsertLicensePayload, InsertLicenseResponse, Province, StatusAPIResponseMain, UpdateLicensePayload, VehicleDetail } from '../../../../../core/models/information.model';

import { async, firstValueFrom, Subscription } from 'rxjs';
import { VehicleData } from '../../../../../core/models/user.model';
import { FormsModule } from '@angular/forms';
import { PssLoadingComponent } from "../../../../../tools/template/pss/pss-loading/pss-loading.component";
import { ToastWarnComponent } from "../../../../../tools/template/toast/toast-warn/toast-warn.component";
import { ToastFailedComponent } from "../../../../../tools/template/toast/toast-failed/toast-failed.component";
import { ToastSuccessComponent } from "../../../../../tools/template/toast/toast-success/toast-success.component";
import { ModalConfirmComponent } from "../../../../../tools/modals/modal-confirm/modal-confirm.component";
import { ToastCustomService } from '../../../../../tools/services/toast/toast-custom/toastCustom.service';
import { PssWarnComponent } from "../../../../../tools/template/pss/pss-warn/pss-warn.component";
import { ApiVehicleService } from '../../../../../core/services/api/Vehicle/api-vehicle';
import { ApiLicenseService } from '../../../../../core/services/api/Vehicle/api-license';

@Component({
  selector: 'app-vehicles-setting-2',
  imports: [CommonModule, FormsModule, PssLoadingComponent, PssWarnComponent],
  templateUrl: './vehicles-setting-2.component.html',
  styleUrl: './vehicles-setting-2.component.css'
})
export class VehiclesSetting2Component {
  currentLang: "TH" | "EN" = "TH";

  stateProgress: number = 1;
  userStatus: boolean = false;
  sub!: Subscription;

  isOpenTypeVehicle: boolean = false;
  isOpenModel: boolean = false;
  isOpenColor: boolean = false;



  optionTypeVehicles = ['รถยนต์', 'รถจักรยานยนต์', 'รถบรรทุก', 'อื่น ๆ'];
  optionModels = ["Honda", "Toyota", "Nissan", "Mitsubishi", "Suzuki", "Honda", "Toyota", "Nissan", "Mitsubishi", "Suzuki"];
  optionColors = ['สีขาว', 'สีดํา', 'สีเหลือง', 'สีน้ําเงิน', 'อื่น ๆ'];

  disabled: boolean = true;
  addNew: boolean = false;
  licenseError: string | null = null;
  selectedCar: string | null = null;
  selectedBrand: string | null = null;
  selectEngine: string | null = null;
  selectedModel: string | null = null;
  selectedColor: string | null = null;
  carId: number = 0;
  searchText: string = ''; // ค่าเริ่มต้นสำหรับการค้นหา
  selectedProvince: any = null;
  searchTerm: string = '';
  provinceSearchText = '';
  activeProvinceDropdown = false;
  license: string = '';
  isOpen: boolean = false;
  token: string = '';
  uid: string = '';
  vehicleDetails: VehicleDetail[] = [];
  colors: Color[] = [];
  provinces: Province[] = [];
  ColorOptions: { value: string; label: string }[] = [];
  ProvinceOptions: { value: string; label: string }[] = [];
  CarOptions: { value: string; label: string }[] = [];
  isLoading: boolean = false; // สถานะการโหลดข้อมูล
  isSaveLoading: boolean = false;
  BrandOptions: { value: string; label: string }[] = [];
  ModelOptions: { value: string; label: string }[] = [];
  showModal = false;
  isConfirm: boolean = false;

  //Old Data for Edit
  oldLicense: string = '';
  oldVehicleType: string = '';
  oldBrand: string = '';
  oldModel: string = '';
  oldEngineType: string = '';
  oldColor: string = '';
  oldProvince: string = '';
  statusVehicleId: number = 2;

  // Alert
  isSuccess: boolean = false;
  textSuccess: string = '';
  detailSuccess: string = '';
  isWarning: boolean = false
  textWarn: string = ''
  detailWarn: string = ''
  isError: boolean = false
  textError: string = ''
  detailError: string = ''
  isWarningModal: boolean = true;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private tokenService: TokenService,
    private apiVehicleService: ApiVehicleService,
    private apiLicenseService: ApiLicenseService,
    private cookie: CookieService,
    private toast: ToastNotifService,
    private toastCustomService: ToastCustomService,
    private languageService: LanguageService
  ) {
    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras?.state as
      | { carId?: number; addNew: boolean; stateProgress: number }
      | undefined;
    // console.log(state);
    this.carId = state?.carId ?? 0;
    this.stateProgress = state?.stateProgress ?? 0;
    console.log('state', state);
    if (state) {
      this.userStatus = true;
      this.addNew = state.addNew;
    }
    console.log('VehicleSettingComponent', this.carId);
    this.sub = this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });
  }
  async ngOnInit(): Promise<void> {
    this.uid =
      this.cookie.get('line_uid') || localStorage.getItem('line_uid') || '';
    // JWT is HttpOnly cookie — token_user no longer used
    this.token = '';
    await this.requestGetCarDetail();

    if (this.carId > 0) {
      this.userStatus = true;
      this.getUserVehicle();
    } else if (this.addNew) {
      this.userStatus = true;
    } else {
      console.warn('No carId provided in router state.');
    }
  }



  /* ---------------------------------------- Function ---------------------------------- */
  /* --- Style --- */
  showWarning(text: string, detail: string = '') {
    // this.toast.warning(text);
    this.toastCustomService.showWarning('', text)
  }
  showError(text: string, detail: string = '') {
    // this.toast.error(text);
    this.toastCustomService.showError('', text)
  }
  showSuccess(text: string, detail: string = '') {
    // this.toast.success(text);
    this.toastCustomService.showSuccess('', text)
  }

  toggleDropdownTypeVehicle() {
    this.isOpenTypeVehicle = !this.isOpenTypeVehicle;
    if (this.isOpenTypeVehicle) {
      this.isOpenModel = false;
      this.isOpenColor = false;
    }
  }
  toggleDropdownModel() {
    this.isOpenModel = !this.isOpenModel;
    if (this.isOpenModel) {
      this.isOpenColor = false;
      this.isOpenTypeVehicle = false;
    }
  }
  toggleDropdownColor() {
    this.isOpenColor = !this.isOpenColor;
    if (this.isOpenColor) {
      this.isOpenModel = false;
      this.isOpenTypeVehicle = false;
    }
  }
  closeWarnModal() {
    this.isWarningModal = false
    this.detailWarn = ''
  }

  /* ---- Function ---- */


  getUserVehicle() {
    //ข้อมูล
    this.apiVehicleService
      .getUserVehicleById(this.token, this.uid, this.carId)
      .subscribe({
        next: (response: any) => {
          console.log('UserVehicleResponse', response);
          if (!response) {
            this.showError('ดึงข้อมูลไม่สำเร็จ');
            return;
          }

          // Robust support for direct VehicleData or wrapped UserVehicleResponse
          const data: VehicleData = response.data ? response.data : response;

          this.disabled = false;
          if (data && data.license && data.license.trim() !== '') {
            this.license = data.license;
            this.oldLicense = this.license;
            this.oldProvince = data.province_name;
            this.oldBrand = data.brand_name;
            this.oldModel = data.model_name;
            this.oldColor = data.color_name;
            this.oldVehicleType = data.vehicle_type_name;

            const initialProvinceId = (data.province_name || '').toString().toLowerCase();

            const match2 = this.ProvinceOptions.find(
              (p) => (p.value || '').toLowerCase() === initialProvinceId
            );
            if (match2) {
              this.selectedProvince = match2;
              this.provinceSearchText = match2.label;
            }

            const defaultCar = this.CarOptions.find(
              (opt) => (opt.value || '').toLowerCase() === (data.vehicle_type_name || '').toLowerCase()
            );
            this.selectedCar = defaultCar ? defaultCar.value : null;

            this.updateBrandOptions(this.selectedCar || '');

            const defaultColor = this.ColorOptions.find(
              (opt) => (opt.value || '').toLowerCase() === (data.color_name || '').toLowerCase()
            );
            this.selectedColor = defaultColor ? defaultColor.value : null;

            const defaultBrand = this.BrandOptions.find(
              (opt) => (opt.value || '').toLowerCase() === (data.brand_name || '').toLowerCase()
            );
            this.selectedBrand = defaultBrand ? defaultBrand.value : null;

            this.updateModelOptions(this.selectedBrand || '');

            const defaultModel = this.ModelOptions.find(
              (opt) => (opt.value || '').toLowerCase() === (data.model_name || '').toLowerCase()
            );
            this.selectedModel = defaultModel ? defaultModel.value : null;

            const match = this.ProvinceOptions.find(
              (p) => (p.value || '').toLowerCase() === initialProvinceId
            );
            if (match) {
              this.selectedProvince = match;
              this.provinceSearchText = match.label;
            }
            console.log(
              'Selected Response:', this.selectedProvince + ' ',
              this.selectedCar + ' ',
              this.selectedBrand + ' ',
              this.selectedModel + ' ',
              this.selectedColor
            );
          } else {
            console.log('No data');
          }
        },
        error: (error) => {
          console.error('API error:', error);
          this.isLoading = false;
        },
      });
  }

  openModal() {
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
  }

  confirmDelete() {
    // ทำสิ่งที่คุณต้องการ เช่นลบข้อมูล
    console.log('ลบเรียบร้อย!');
    this.closeModal();
  }


  async requestGetCarDetail(): Promise<void> {
    try {
      this.isLoading = true;
      this.token = '';
      // console.log('Token:', this.token);

      const response: InformationResponse = await firstValueFrom(
        this.apiVehicleService.getCarDetail(this.token)
      );

      this.vehicleDetails = response.vehicle_detail;
      this.ColorOptions = response.color.map((color: Color) => ({
        value: color.name.toLowerCase(),
        label: color.name,
      }));

      this.ProvinceOptions = response.province.map((province: Province) => ({
        value: province.name.toLowerCase(),
        label: province.name,
      }));

      this.CarOptions = [
        ...new Set(
          response.vehicle_detail.map((vehicleDetail: VehicleDetail) =>
            vehicleDetail.vehicle_type_name.toLowerCase()
          )
        ),
      ].map((vehicleTypeName: string) => ({
        value: vehicleTypeName,
        label:
          vehicleTypeName.charAt(0).toUpperCase() + vehicleTypeName.slice(1),
      }));

      this.isLoading = false;
    } catch (error) {
      console.error('API error:', error);
      this.isLoading = false;
    }
  }

  save() {
    this.closeModal();
    console.log(
      "Data save Payload: ",
      this.license,
      this.selectedProvince,
      this.selectedCar,
      this.selectedBrand,
      this.selectedModel,
      this.selectedColor,
      this.selectEngine
    );
    if (this.license.trim() == '') {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณากรอกหมายเลขทะเบียน'
          : 'Please enter the license plate number.'
      );
    } else if (!this.selectedProvince) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุจังหวัด'
          : 'Please specify the province.'
      );
    } else if (this.selectedCar == '' || !this.selectedCar) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาเลือกประเภทรถ'
          : 'Please select the vehicle type.'
      );
    }
    else if (this.selectedColor == '') {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาเลือกสีของรถ'
          : 'Please select the color.'
      );
    } else {
      this.openModal();
    }
  }

  sendApi() {
    if (this.disabled) {
      this.sendInsertLicense();
    } else {
      if (this.carId > 0) {
        this.showModal = false;
        this.sendUpdateLicense();
      } else {
        console.log('No ID Vehicle');
      }
    }
  }

  /* ------------------------------------------ API ------------------------------------------ */

  sendInsertLicense() {
    this.closeModal();
    this.isSaveLoading = true;
    this.token = '';
    // console.log('Token:', this.token);

    const payload: InsertLicensePayload = {
      uid: this.cookie.get('line_uid'),
      license: this.license.replace(/[^ก-ฮa-zA-Z0-9]/g, ''),
      vehicle_type: this.selectedCar || '',
      brand: /*this.selectedBrand ||*/ this.selectedCar == "รถยนต์" ? 'Acura' : 'Honda',
      model: /*this.selectedModel ||*/ this.selectedCar == "รถยนต์" ? 'Integra' : 'ADV160',
      engine_type: this.selectEngine || '',
      color: /*this.selectedColor || */this.selectedCar == "รถยนต์" ? 'ดำ' : 'ดำ',
      province: this.selectedProvince.value,
    };
    console.log('Payload:', payload);
    this.apiLicenseService.insertLicense(payload, this.token).subscribe({
      next: (res: InsertLicenseResponse) => {
        console.log('📦 Response:', res);
        if (res.code == '000') {
          this.isSaveLoading = false;
          this.showSuccess(
            this.currentLang === 'TH' ? 'ทำการบันทึกเรียบร้อย' : 'Saved successfully.'
          );
          setTimeout(() => {
            // this.router.navigate(['/payment-setting']);
            this.clickSkips();
          }, 0);
        } else {
          this.showError(
            this.currentLang === 'TH'
              ? res.message
              : res.message_en
          );
        }
      },
      error: (err) => {
        console.error('❌ ส่ง OTP ไม่สำเร็จ:', err);
        this.showError(
          this.currentLang === 'TH' ? 'บันทึกไม่สำเร็จ' : 'Save not successful.'
        );
        this.isSaveLoading = false;
      },
      complete: () => {
        this.isSaveLoading = false;
      },
    });
    //   },
    //   error: (error) => {
    //     console.error('Token error:', error);
    //     this.showError('บันทึกไม่สำเร็จ');
    //     this.isLoading = false;
    //   },
    // });
  }
  sendUpdateLicense() {
    const payload: UpdateLicensePayload = {
      uid: this.uid,
      oldLicense: this.oldLicense,
      license: this.license.replace(/[^ก-ฮa-zA-Z0-9]/g, ''),
      id: this.carId,
      oldVehicleType: this.oldVehicleType,
      vehicleType: this.selectedCar || '',
      oldBrand: this.oldBrand,
      brand: /*this.selectedBrand || */ this.selectedCar == "รถยนต์" ? 'Acura' : 'Honda',
      oldModel: this.oldModel,
      model: /*this.selectedModel || */ this.selectedCar == "รถยนต์" ? 'Integra' : 'ADV160',
      oldEngineType: '',
      engineType: '',
      oldColor: this.oldColor,
      color: /*this.selectedColor ||*/ this.selectedCar == "รถยนต์" ? 'ดำ' : 'ดำ',
      oldProvince: this.oldProvince,
      province: this.selectedProvince.value,
      statusVehicleId: this.statusVehicleId,
    };
    console.log(payload);
    if (payload) {
      this.apiVehicleService.updateCityVehicle(payload, this.token).subscribe({
        next: (res: StatusAPIResponseMain) => {
          console.log('📦 Response:', res);
          this.isLoading = false;
          if (res) {
            if (res.code == '000') {
              this.showSuccess(res.message);
              console.log(this.currentLang)
              setTimeout(() => {
                this.clickSkips();
              }, 100);
            } else {
              this.showError(res.message);
            }
          } else {
            this.showError('can not delete this Vehicle');
          }
        },
        error: (err) => {
          console.error('❌  not succeed:', err);
          this.isLoading = false;
          this.showError('can not delete this Vehicle');
        },
      });
    } else {
      console.log('No Payload');
    }
  }

  filterProvinces() {
    return this.ProvinceOptions.filter((ProvinceOptions) =>
      ProvinceOptions.label
        .toLowerCase()
        .includes(this.searchTerm.toLowerCase())
    );
  }

  handleCarChange(value: string): void {
    const selectedOption = this.CarOptions.find(
      (option) => option.value === value
    );
    if (selectedOption) {
      console.log(`Selected CAR  ID: ${selectedOption.value}`);
      this.selectedCar = value; // อัปเดตค่า selectedRam เมื่อเลือก

      this.updateBrandOptions(selectedOption.value);
    }
  }

  updateBrandOptions(vehicleType: string): void {
    // กรองข้อมูลตามประเภทที่เลือก
    const filteredBrands = this.vehicleDetails
      .filter((vehicle) => vehicle.vehicle_type_name === vehicleType) // กรองตามประเภทที่เลือก
      .map((vehicle) => vehicle.vehicle_brand_name); // ดึงแค่ vehicle_brand_name

    // กรองค่าซ้ำจาก filteredBrands
    const uniqueBrands = [...new Set(filteredBrands)];
    this.selectedBrand = '';
    this.selectedModel = '';
    // อัปเดต BrandOptions โดยใช้ค่าที่ไม่ซ้ำดอ
    this.BrandOptions = uniqueBrands.map((brand) => ({
      value: brand,
      label: brand,
    }));
  }

  updateModelOptions(brand: string): void {
    // กรองข้อมูลตามประเภทที่เลือก
    const filteredModel = this.vehicleDetails
      .filter(
        (brands) =>
          brands.vehicle_brand_name === brand &&
          brands.vehicle_type_name === this.selectedCar
      ) // กรองตามประเภทที่เลือก
      .map((brands) => brands.vehicle_model_name); // ดึงแค่ vehicle_brand_name

    // กรองค่าซ้ำจาก filteredBrands
    const uniqueBrands = [...new Set(filteredModel)];
    this.selectedModel = '';
    this.selectEngine = '';
    // อัปเดต BrandOptions โดยใช้ค่าที่ไม่ซ้ำดอ
    this.ModelOptions = uniqueBrands.map((model) => ({
      value: model,
      label: model,
    }));
  }

  handleBrandChange(option: any): void {
    this.selectedBrand = option.value;
    console.log('Selected Brand ID:', this.selectedBrand);
    this.isOpenTypeVehicle = false;
    this.updateModelOptions(this.selectedBrand || '');
  }
  handleModelChange(option: any): void {
    this.selectedModel = option.value;
    this.selectEngine = '';
    this.isOpenModel = false;
    console.log('Selected Model ID:', this.selectedModel);

    const filteredEngines = this.vehicleDetails
      .filter(
        (brands) =>
          brands.vehicle_brand_name === this.selectedBrand &&
          brands.vehicle_type_name === this.selectedCar &&
          brands.vehicle_model_name === this.selectedModel
      ) // กรองตามประเภทที่เลือก
      .map((brands) => brands.vehicle_engine_name);

    this.selectEngine = filteredEngines[0] || '';
    console.log('Selected Engine:', this.selectEngine);
  }
  handleColorChange(option: any): void {
    this.selectedColor = option.value;
    this.isOpenColor = false;
    console.log('Selected Color ID:', this.selectedColor);
  }

  handleProvinceChange(event: any) {
    if (event) {
      console.log(event);
    } else {
      console.error('Event is undefined or null');
    }
  }

  clickSkips() {
    setTimeout(() => {
      // this.router.navigate(['/payment-setting']);
      // if (this.userStatus) {
      //   this.router.navigate(['/vehicles-option']);
      // } else {
      //   this.router.navigate(['/vehicles-option']);
      // }
      this.router.navigate(['/vehicles-option']);
    }, 0);
  }

  validateLicense(): void {
    const pattern = /^(\d?[ก-ฮ]{1,3})\s?\d{1,4}$/;
    this.licenseError = pattern.test(this.license.trim())
      ? null
      : 'รูปแบบทะเบียนไม่ถูกต้อง (ตัวอักษรไทย 1-3 ตัว + เลข 1-4 หลัก)';
  }

  get filteredProvinceOptions() {
    const text = this.provinceSearchText.trim().toLowerCase();
    if (!text) return this.ProvinceOptions;
    return this.ProvinceOptions.filter(p => (p.label || '').toLowerCase().includes(text));
  }

  openProvinceDropdown() {
    this.activeProvinceDropdown = true;
  }

  closeProvinceDropdown() {
    setTimeout(() => {
      this.activeProvinceDropdown = false;
      const match = this.ProvinceOptions.find(p => p.label === this.provinceSearchText);
      if (match) {
        this.selectedProvince = match;
      } else {
        this.provinceSearchText = this.selectedProvince ? this.selectedProvince.label : '';
      }
    }, 200);
  }

  selectProvinceOption(p: any) {
    this.selectedProvince = p;
    this.provinceSearchText = p.label;
    this.activeProvinceDropdown = false;
  }

  goback() {
    this.router.navigate(['/vehicles-option']);
  }
}
